export default "__VITE_ASSET__00y1xVIK__"